import { object, string } from 'yup'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { ContentPlan } from 'blaze-ui/icons/36'
import { website } from './shared/website'
import { MultiStepSchema } from './Types'
import { FormSchema } from '../Wizard/Form/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { safify } from './utils/safify'
import { TextChannels } from '../../../constants'

const meta = {
  type: GenerationType.ContentPlan,
  steps: ['Set Topic', 'Confirm Details', 'Generate'],
  title: TextChannels[GenerationType.ContentPlan].name,
  submitLabel: 'Generate',
  icon: ContentPlan,
  channel: GenerationType.ContentPlan,
  previewUrl: '',
}

const fields = {
  website: website.meta({ label: 'Start with your website ' }),
  topic: string()
    .default('')
    .meta({
      placeholder: "Ex: I have a lawn care business and I'd like to get more leads from social media.",
      rows: 4,
      snippets: true,
      typeahead: true,
    })
    .transform(safify)
    .meta({
      label: 'And/or tell us more about your company or product',
      generationType: meta.type,
    }),
}

export const ContentPlanSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const topicStep = ContentPlanSchema.meta({ title: 'Set Topic', submitLabel: 'Confirm Details' })
const confirmDetailsStep = object().meta({
  type: GenerationType.ContentPlan,
  title: 'Confirm Details',
  submitLabel: 'Generate',
})
export const scrapeErrorStep = object({
  websiteText: string()
    .default('')
    .meta({
      label: "Copy and paste the text from your website into the box, and we'll try again.",
      placeholder: 'Paste text',
      rows: 8,
    })
    .transform(safify)
    .required(),
}).meta({
  type: GenerationType.ContentPlan,
  title: 'Set Topic',
  submitLabel: 'Analyze Content',
})

export const MultiStepContentPlanSchema = {
  meta,
  steps: [topicStep, confirmDetailsStep],
} as MultiStepSchema
